import CryptoJS from 'crypto-js';


export default class ChatBotEncodeDecodeService {
    static encode(data) {
        const base64Key = "dHJhaW5lcl9hdXRoUGxheQ==";
        const key = CryptoJS.enc.Base64.parse(base64Key);
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encryptedData.toString();
    }

    static decode(data) {
        const base64Key = "dHJhaW5lcl9hdXRoUGxheQ==";
        const key = CryptoJS.enc.Base64.parse(base64Key);
        const decryptedData = CryptoJS.AES.decrypt(data, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
    }

}

